// create dataLayer

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

// set Usercentrics developer_id
gtag("set", "developer_id.dY2M3M2", true);

// set „denied" as default for both ad and analytics storage,
gtag("consent", "default", {
  ad_user_data: "denied",
  ad_personalization: "denied",
  ad_storage: "denied",
  analytics_storage: "denied",
  wait_for_update: 2000 // milliseconds to wait for update
});

// Enable ads data redaction by default [optional]
gtag("set", "ads_data_redaction", true);

  
// load tag manager
(function(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js"
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.dataset.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-5G8NRN2");

  

// listen on events that give/revoke consent and send it to gtm
window.addEventListener("ucEvent", function(e) {
  if (e.detail && e.detail.event == "consent_status") {
    var ucAnalyticsService = "Google Analytics";
    var ucAdService = "Google Ads";
    if (
      e.detail.hasOwnProperty(ucAdService) &&
      e.detail.hasOwnProperty(ucAdService)
    ) {
      gtag("consent", "update", {
        ad_storage: e.detail[ucAdService] ? "granted" : "denied",
        analytics_storage: e.detail[ucAnalyticsService] ? "granted" : "denied"
      });
    } else {
      if (e.detail.hasOwnProperty(ucAdService)) {
        gtag("consent", "update", {
          ad_storage: e.detail[ucAdService] ? "granted" : "denied"
        });
      }
      if (e.detail.hasOwnProperty(ucAnalyticsService)) {
        gtag("consent", "update", {
          analytics_storage: e.detail[ucAnalyticsService] ? "granted" : "denied"
        });
      }
    }
  }
});
